/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Log_NoteInputs */

const en_how_we_work_log_note = /** @type {(inputs: How_We_Work_Log_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An example of the improvement cycle.`)
};

const lv_how_we_work_log_note = /** @type {(inputs: How_We_Work_Log_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzlabošanas cikla piemērs.`)
};

/**
* | output |
* | --- |
* | "An example of the improvement cycle." |
*
* @param {How_We_Work_Log_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_log_note = /** @type {((inputs?: How_We_Work_Log_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Log_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_log_note(inputs)
	return en_how_we_work_log_note(inputs)
});